import React, { useState } from 'react';
import { useHint } from './context/useHintContext';
import { useHintContainer } from './context/useHintContainerContext';
import { useOvertime } from './context/useOvertimeContext';
import Sound from 'react-sound';
import { useTimer } from 'react-compound-timer';
import { toast } from 'react-toastify';
import { ErrorBoundary } from 'react-error-boundary';

import LoginForm from './components/LoginForm/index';
import Intro from './components/Intro/index';
import { Round, RoundText } from './components/Round/index';
import HintContainer from './components/HintContainer/index';
import VictoryScreen from '../VictoryScreen/index';
import Logo from '../../assets/Logo.png';
import { ErrorFallback } from './components/ErrorFallback/index';
import {
  PageContainer,
  TimeDeduct,
  GridInput,
  GridHint,
  GridOpdracht,
  LogoStyle,
  GridLayout,
  LogoHeading,
  TimeValue,
} from './styled';
import { BASE_URLS } from '../constants';

const GameScreen = () => {
  const {
    step,
    stepCounter,
    setTotalRoundsNumber,
    timerHandler,
    setuseHintLogin,
  } = useHint();

  const { setQueue, setVisible, setGameLogin, setDocumentId } =
    useHintContainer();

  const { playTimer, setPlay, overtime, triggerOvertime } = useOvertime();

  const {
    value,
    controls: { setTime, start, getTime, pause, setCheckpoints },
  } = useTimer({
    initialTime: 0,
    direction: 'forward',
    startImmediately: false,
  });

  const [game, gameHandler] = useState([]);
  const [round, roundCounter] = useState(1);
  const [docId, setDocId] = useState('');
  const [deductAnimation, setDeductAnimation] = useState(false);

  const handleGameSubmit = (game, documentId) => {
    const num = game.playerGame.rounds.length;
    setDocId(documentId);
    setDocumentId(documentId);
    gameHandler(game);
    setTotalRoundsNumber(num);
    setGameLogin(game.login);
    setuseHintLogin(game.login);

    setCheckpoints([
      {
        time: game.playerGame.gameTotalTime || 3600000,
        callback: () => triggerOvertime(),
      },
    ]);

    function lsTest() {
      const test = 'test';
      try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
      } catch (e) {
        return false;
      }
    }

    // hints worden niet gezet inronde 1 zonder een round component in localStorage
    if (
      lsTest() === true &&
      `HUISARREST_ROUND_${game.login}` in localStorage &&
      `HUISARREST_MAINTIMER_${game.login}` in localStorage
    ) {
      let keyString = localStorage.getItem(`HUISARREST_ROUND_${game.login}`);
      let timerString = localStorage.getItem(
        `HUISARREST_MAINTIMER_${game.login}`
      );

      let newRoundKey = parseInt(keyString);
      let timerKey = parseInt(timerString);

      toast(
        `Je hebt een onafgerond spel. Het spel zal hervatten vanaf ronde ${newRoundKey}`
      );
      setTime(timerKey);
      roundCounter(newRoundKey);
      stepCounter(step + 1);
    } else {
      stepCounter(step + 1);
    }

    if (
      lsTest() === true &&
      `HUISARREST_HINT_HIDDEN_QUEUE_${game.login}` in localStorage
    ) {
      let items = JSON.parse(
        localStorage.getItem(`HUISARREST_HINT_HIDDEN_QUEUE_${game.login}`)
      );
      setQueue(items);
    }

    if (
      lsTest() === true &&
      `HUISARREST_HINT_VISIBLE_QUEUE_${game.login}` in localStorage
    ) {
      let items = JSON.parse(
        localStorage.getItem(`HUISARREST_HINT_VISIBLE_QUEUE_${game.login}`)
      );
      setVisible(items);
    }
  };

  if (game === undefined) {
    return null;
  }

  const renderGameScreen = () => {
    switch (step) {
      case 1:
        return (
          <LoginForm
            nextStep={() => stepCounter(step + 1)}
            gameSubmit={handleGameSubmit}
          />
        );
      case 2:
        return (
          <Intro
            game={game}
            nextStep={() => stepCounter(step + 1)}
            startTimer={() => timerHandler(true)}
          />
        );
      case 3:
        timerHandler(true);
        return (
          <div>
            <Sound
              url='clock.mp3'
              autoload={true}
              playStatus={Sound.status.PLAYING}
            />
            <LogoHeading>
              <LogoStyle src={Logo} alt='Logo' />
            </LogoHeading>
            <GridLayout>
              <GridOpdracht>
                <RoundText
                  game={game}
                  nextStep={() => stepCounter(step + 1)}
                  round={round}
                  roundCounter={roundCounter}
                />
              </GridOpdracht>
              <GridInput>
                <Round
                  game={game}
                  startTimer={() => timerHandler(true)}
                  nextStep={() => stepCounter(step + 1)}
                  round={round}
                  roundCounter={roundCounter}
                  getTime={getTime}
                  deductTimeAnimation={() => {
                    setTime(getTime() + 60000);
                    setDeductAnimation(true);
                    setTimeout(() => {
                      setDeductAnimation(false);
                    }, 5000);
                  }}
                />
              </GridInput>
              <GridHint>
                <HintContainer game={game} round={round} />
              </GridHint>
            </GridLayout>
          </div>
        );
      case 5:
        setPlay(false);
        const initialUrl = `${BASE_URLS.HUISARREST_BASE_URL}/contact`;
        const initialWinnerText =
          'Woehoe, you did it! Binnen de tijd het mysterie ontrafeld, dat lukt niet iedereen. Gefeliciteerd!! Jullie eindtijd is:';
        const initialLoserText =
          "Het is jullie gelukt! Ok\u00E9, niet binnen de tijd but who's counting?! Jullie hebben het mysterie maar mooi opgelost! Jullie eindtijd is:";

        return (
          <VictoryScreen
            documentId={docId}
            winnerText={game?.playerGame?.winnerText || initialWinnerText}
            loserText={game?.playerGame?.loserText || initialLoserText}
            completionUrl={game?.playerGame?.completionUrl?.url || initialUrl}
            gameTotalTime={game?.playerGame?.gameTotalTime || 3600000}
          />
        );
      default:
        return <p>joejoe</p>;
    }
  };

  return (
    <PageContainer>
      <>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            window.location.reload();
          }}
        >
          {renderGameScreen()}
        </ErrorBoundary>
        <div className='Timer' id='Timer'>
          <TimeDeduct
            className={`deduct deduct-${deductAnimation}`}
            active={deductAnimation}
          >
            +01:00
          </TimeDeduct>
          {playTimer ? (
            <>
              {start()}
              <TimeValue overTime={overtime}>
                {value.h >= 1 ? `0${value.h}:` : null}
                {value.m < 10 ? `0${value.m}` : value.m}:
                {value.s < 10 ? `0${value.s}` : value.s}
              </TimeValue>
            </>
          ) : (
            <>{pause()}</>
          )}
        </div>
      </>
    </PageContainer>
  );
};

export default GameScreen;
